import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthProvider } from "pages/Auth/hooks/useAuthProvider";
const AuthGuard = ({ component }) => {
    const { isSessionAuthenticated } = useAuthProvider();
    const [status, setStatus] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        verifyIsAuthenticated();
    }, [component]);

    const verifyIsAuthenticated = () => {
        if (isSessionAuthenticated() == true) {
            setStatus(true);
            return;
        }
        else {
            navigate(`/error`);
        }
    }
    return status ? <React.Fragment>{component} </React.Fragment> : <React.Fragment></React.Fragment >;
}

export default AuthGuard;